(function() {
  'use strict';
  function initMenu() {

  var params = new URLSearchParams(window.location.search);
  var tienda = params.get('tienda') || '';
  var tipo = params.get('tipo') || 'cafeteria';
  var idiomas = (params.get('idiomas') || 'es,en,eu,ca').split(',');
  var lang = params.get('lang') || idiomas[0] || 'es';

  var storeNames = {
    'almirante': 'East Crema Coffee Almirante',
    'nieremberg': 'East Crema Coffee Nieremberg',
    'diego-leon': 'East Crema Coffee Diego de León',
    'hermosilla': 'East Crema Coffee Hermosilla',
    'castellana': 'East Crema Coffee Castellana',
    'conde-penalver': 'East Crema Coffee Conde de Peñalver',
    'preciados': 'East Crema Coffee Preciados',
    'eloy': 'East Crema Coffee Eloy Gonzalo',
    'alfonso-x': 'East Crema Coffee Alfonso X',
    'ercilla': 'East Crema Coffee Ercilla',
    'ajuriaguerra': 'East Crema Coffee Ajuriaguerra',
    'rodriguez-arias': 'East Crema Coffee Rodríguez Arias',
    'astarloa': 'East Crema Coffee Astarloa',
    'hernani': 'East Crema Coffee Hernani',
    'diagonal': 'East Crema Coffee Diagonal',
    'roger': 'East Crema Coffee Roger de Llúria',
    'almirantcadarso': 'East Crema Coffee Almirante Cadarso',
    'sorni': 'East Crema Coffee Sorní',
    'santa-maria': 'East Crema Coffee Santa María',
    'sanclemente': 'East Crema Coffee Sanclemente',
    'principe': 'East Crema Coffee Príncipe',
    'granvia': 'East Crema Coffee Gran Vía'
  };

  if (tienda && storeNames[tienda]) {
    var banner = document.getElementById('menu-store-name');
    if (banner) {
      banner.style.display = '';
      banner.querySelector('.menu-store-name__text').textContent = storeNames[tienda];
    }
  }

  var storeGroups = {
    'madrid': ['almirante','nieremberg','diego-leon','hermosilla','castellana','conde-penalver','preciados','eloy','alfonso-x','principe','granvia'],
    'paisvasco': ['ercilla','ajuriaguerra','rodriguez-arias','astarloa','hernani'],
    'barcelona': ['diagonal','roger'],
    'valencia': ['almirantcadarso','sorni'],
    'sevilla': ['santa-maria'],
    'zaragoza': ['sanclemente']
  };

  function applyStoreFilter() {
    if (!tienda) return;

    document.querySelectorAll('[data-store-group]').forEach(function(el) {
      var group = el.getAttribute('data-store-group');
      if (group && group !== 'all' && group !== 'custom') {
        var groupStores = storeGroups[group] || [];
        if (groupStores.indexOf(tienda) === -1) {
          el.style.display = 'none';
          el.setAttribute('data-store-hidden', 'true');
        }
      }
    });

    document.querySelectorAll('[data-stores]').forEach(function(el) {
      var allowed = el.getAttribute('data-stores').split(',').map(function(s) { return s.trim(); });
      if (allowed.indexOf(tienda) === -1) {
        el.style.display = 'none';
        el.setAttribute('data-store-hidden', 'true');
      }
    });
  }

  function setTipo(t) {
    tipo = t;
    document.querySelectorAll('#menu-type-selector [data-type]').forEach(function(btn) {
      btn.classList.toggle('menu-topbar__btn--active', btn.getAttribute('data-type') === t);
    });

    document.querySelectorAll('[data-type-only]').forEach(function(el) {
      var restriction = el.getAttribute('data-type-only');
      if (restriction === t || restriction === 'all') {
        if (!el.hasAttribute('data-store-hidden')) {
          el.style.display = '';
        }
      } else {
        el.style.display = 'none';
      }
    });

    document.querySelectorAll('[data-text-' + t + ']').forEach(function(el) {
      el.textContent = el.getAttribute('data-text-' + t);
    });
  }

  function setLang(l) {
    lang = l;
    document.querySelectorAll('#menu-lang-selector [data-lang]').forEach(function(btn) {
      btn.classList.toggle('menu-topbar__lang-btn--active', btn.getAttribute('data-lang') === l);
    });
    document.querySelectorAll('[data-i18n]').forEach(function(el) {
      var key = el.getAttribute('data-i18n');
      var elLang = key.split('_').pop();
      el.style.display = elLang === l ? '' : 'none';
    });
  }

  function setTab(tab) {
    document.querySelectorAll('.menu-tabs__link').forEach(function(btn) {
      btn.classList.toggle('menu-tabs__link--active', btn.getAttribute('data-tab') === tab);
    });
    document.querySelectorAll('.menu-tab-content').forEach(function(content) {
      content.style.display = content.getAttribute('data-tab-content') === tab ? '' : 'none';
    });
  }

  function filterLangs(available) {
    document.querySelectorAll('#menu-lang-selector [data-lang]').forEach(function(btn) {
      btn.style.display = available.indexOf(btn.getAttribute('data-lang')) !== -1 ? '' : 'none';
    });
  }

  document.querySelectorAll('#menu-type-selector [data-type]').forEach(function(btn) {
    btn.addEventListener('click', function() { setTipo(btn.getAttribute('data-type')); });
  });
  document.querySelectorAll('#menu-lang-selector [data-lang]').forEach(function(btn) {
    btn.addEventListener('click', function() { setLang(btn.getAttribute('data-lang')); });
  });
  document.querySelectorAll('.menu-tabs__link').forEach(function(btn) {
    btn.addEventListener('click', function() { setTab(btn.getAttribute('data-tab')); });
  });

  applyStoreFilter();
  filterLangs(idiomas);
  setTipo(tipo);
  setLang(lang);
  setTab('cafes');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenu);
  } else {
    initMenu();
  }
})();
